<script lang="ts">
    import { primary } from "../theme";

    export let lineLength = 28;
    export let lineWidth = 3;
</script>

<svg width={lineWidth} height={lineWidth} overflow="visible">
    <line
        class="edge"
        x1={0}
        y1={0}
        x2={0}
        y2={lineLength}
        stroke={primary}
        stroke-width={lineWidth}
    />
</svg>

<style lang="scss">
    @import "theme.scss";

    .edge {
        filter: drop-shadow(0px 0px 2px $primary);
    }
</style>
